export const axisRadius = {
    grid: {
        smooth: !0,
        visible: !0
    },
    subGrid: {
        smooth: !0,
        visible: !1
    }
};

export const axisAngle = {
    grid: {
        visible: !0,
        style: {
            lineDash: [ 6, 6 ]
        }
    },
    label: {
        space: 5
    }
};
//# sourceMappingURL=polar-axis.js.map
